<div class="support">
  <div class="support-page-header">
    <div class="logo-container">
      <img class="logo-container-img" src="assets/images/logo/zenity-logo.svg" />
      <img class="logo-container-text" src="assets/images/logo/zenity-text.svg" />
    </div>
  </div>
  <div class="support-page-content">
    <div class="card-layout">
      <div class="support-page-content-success-message" *ngIf="showSuccessMessage">
        {{ 'supportPage.tickets.successMessage' | labelsProvider }}
      </div>

      <div *ngIf="!showSuccessMessage">
        <p class="support-title">
          {{ 'supportPage.tickets.new_ticket_title' | labelsProvider }}
        </p>
        <div class="support-card">
          <div class="support-card-inputs" [formGroup]="fg">
            <div class="support-card-inputs-input">
              <div class="support-card-inputs-input-title">
                {{ 'supportPage.tickets.title' | labelsProvider }}
              </div>
              <div class="support-card-inputs-input-value">
                <input
                  class="support-card-inputs-input-text-field"
                  formControlName="title"
                  type="text"
                  placeholder="{{ 'common.text_input_placeholder' | labelsProvider }}"
                  [ngClass]="{
                    'support-card-inputs-input-invalid':
                      fg.controls['title'].errors && fg.controls['title'].errors['required'] && submitAttempt,
                  }"
                />
              </div>
            </div>
            <div class="error-message" *ngIf="fg.controls['title'].invalid && fg.controls['title'].value.length !== 0">
              Maximum of
              {{ TITLE_MAXIMUM_LENGTH }}
              characters is reached
            </div>

            <div class="support-card-inputs-input">
              <div class="support-card-inputs-input-title">
                {{ 'supportPage.tickets.severity' | labelsProvider }}
              </div>
              <app-select-v2
                class="support-card-inputs-input-value"
                [placeHolder]="'common.select' | labelsProvider"
                [options$]="severityOptions$"
                [selectedId]="fg.controls['severity'].value"
                (optionOnSelection)="severityOnSelection($event)"
                [valid]="severityValid$"
              >
              </app-select-v2>
            </div>

            <div
              class="support-card-inputs-input"
              *ngIf="fg.controls['severity'].value === supportTicketSeverity.urgent"
            >
              <div class="support-card-inputs-input-title">
                {{ 'supportPage.tickets.phone_number' | labelsProvider }}
              </div>
              <div class="support-card-inputs-input-value">
                <input
                  class="support-card-inputs-input-text-field"
                  formControlName="phone_number"
                  type="tel"
                  placeholder="{{ PHONE_INPUT_PLACEHOLDER }}"
                  [ngClass]="{
                    'support-card-inputs-input-invalid':
                      fg.controls['phone_number'].errors &&
                      fg.controls['phone_number'].errors['required'] &&
                      submitAttempt,
                  }"
                />
              </div>
            </div>
            <div
              class="error-message"
              *ngIf="
                fg.controls['severity'].value === supportTicketSeverity.urgent &&
                fg.controls['phone_number'].errors &&
                fg.controls['phone_number'].errors['pattern'] &&
                submitAttempt
              "
            >
              Phone number format must be
              {{ PHONE_INPUT_PLACEHOLDER }}
            </div>

            <div
              class="support-card-inputs-input"
              *ngIf="fg.controls['severity'].value === supportTicketSeverity.urgent"
              [ngClass]="{
                'checkbox-invalid':
                  fg.controls['criticalSeverityApproved'].errors &&
                  fg.controls['criticalSeverityApproved'].errors['required'] &&
                  submitAttempt,
              }"
            >
              <mat-checkbox
                color="primary"
                [checked]="fg.controls['criticalSeverityApproved'].value"
                (change)="toggleCriticalSeverityApproval()"
              >
                {{ 'supportPage.tickets.criticalTicketWarning' | labelsProvider }}
              </mat-checkbox>
            </div>

            <div class="support-card-inputs-input support-card-inputs-input-description">
              <div class="support-card-inputs-input-title">
                {{ 'supportPage.tickets.description' | labelsProvider }}
              </div>
              <textarea
                type="text"
                formControlName="description"
                placeholder="{{ 'common.description_input_placeholder' | labelsProvider }}"
                [ngClass]="{
                  'support-card-inputs-input-invalid': fg.controls['description'].invalid && submitAttempt,
                }"
              ></textarea>
              <div
                class="error-message"
                *ngIf="fg.controls['description'].invalid && fg.controls['description'].value.length !== 0"
              >
                Maximum of
                {{ DESC_MAXIMUM_LENGTH }}
                characters is reached
              </div>
            </div>

            <div class="support-card-inputs-input support-card-file-uploader">
              <input
                id="#SupportHiddenFileUploader"
                type="file"
                multiple
                (change)="onFileSelected($event)"
                hidden="true"
              />
              <div class="support-card-file-uploader-button" (click)="openFileSelectionDialog()">
                <img src="assets/images/common/import.svg" />
                <span>
                  {{ 'common.uploadFiles' | labelsProvider }}
                </span>
              </div>
              <span
                class="support-card-file-uploader-value-text"
                (hidden)="(fileUploaderValueDescription)"
                [matTooltip]="fileUploaderValueTooltip"
                matTooltipClass="tooltip-container"
                matTooltipPosition="below"
                >{{ fileUploaderValueDescription }}</span
              >
            </div>
            <div class="support-card-file-uploader-warning">
              {{ 'supportPage.tickets.uploadFileWarning' | labelsProvider }}
            </div>
          </div>

          <div class="buttons">
            <div
              class="confirm"
              [ngClass]="{
                'confirm-disabled': waitingForResponse,
              }"
              (click)="create()"
              cdkFocusInitial
            >
              <img *ngIf="!waitingForResponse" src="assets/images/common/create.svg" />
              <span *ngIf="!waitingForResponse">{{ 'common.create' | labelsProvider }}</span>
              <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="white" mode="indeterminate">
              </mat-progress-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
